<template>
    <div>
        <div class="pt-2 pr-2">
          <div class="pt-2 text-center pr-2">
            <base-button
              type="info" 
              icon="ni ni-fat-add"
              class="mb-3"
              @click="showDomainModal()">NEW DOMAIN</base-button>
          </div>
          <table>
            <thead>
              <tr>
                <th>Domains</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody v-if="domains.length > 0">
              <tr v-for="(domain, index) in domains" :key="index">
                <td data-label="Domain">
                  <a :href="domain.domain" target="_blank">
                    <badge type="primary" style="color: #666">{{ extractDomain(domain.domain) }}</badge>
                  </a>
                </td>
                <td data-label="Status">
                  <badge type="success" v-if="domain.status == 1">ACTIVE</badge>
                  <badge type="danger" v-else>INACTIVE</badge>
                </td>
                <td data-label="Actions">
                  <base-button
                    type="warning"
                    icon="fa fa-pencil"
                    size="sm"
                    rounded
                    @click="editDomain(domain)"></base-button>
                  <base-button
                    type="danger"
                    icon="fa fa-trash"
                    size="sm"
                    rounded
                    @click="deleteDomain(domain.id)"></base-button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <modal :show.sync="domainModal"
          modal-classes="modal-dialog-centered modal-sm">
          <h6 slot="header" class="modal-title" id="modal-title-default">
            <strong>MANAGE DOMAINS</strong>
          </h6>
          <template>
              <form role="form" style="background: #eee;">
                <base-input alternative
                  ref="domain"
                  type="url"
                  placeholder="Domain"
                  autofocus
                  :valid="form.valid"
                  v-model="form.domain"
                  addon-left-icon="fa fa-globe">
                </base-input>
              </form>
          </template>
          <template slot="footer">
            <base-button type="success" @click="saveDomain()">Save changes</base-button>
          </template>
        </modal>
    </div>
</template>

<script>
import axios from 'axios'
import Modal from "@/components/Modal"
import extractDomain from "extract-domain"
import { parseDomain, fromUrl } from "parse-domain"

export default {
  name: "domains",
  components: {
    Modal
  },
  data() {
    return {
      domains: [],
      domainModal: false,
      form: {
        valid: false,
        domain: ''
      }
    }
  },
  mounted () {
    let vm = this
    vm.load()
  },
  methods: {
    extractDomain (domain) {
      const { subDomains } = parseDomain(
        fromUrl(domain)
      );
      return subDomains.join('.') + extractDomain(domain)
    },
    load () {
      let vm = this
      axios.get(process.env.VUE_APP_API_URL + 'domains/all').then(function (response) {
        vm.domains = response.data.data
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
    },
    showDomainModal () {
      this.domainModal=true
      this.form.domain = ''
      this.form.id = 0
      setTimeout(x => {
        this.$nextTick(() => this.$refs.domain.focus())
      }, 2000);
    },
    editDomain (domain) {
      this.domainModal=true
      this.form.domain = domain.domain
      this.form.id = domain.id
      setTimeout(x => {
        this.$nextTick(() => this.$refs.domain.focus())
      }, 2000);
    },
    saveDomain () {
      let vm = this
      let url = (this.form.id == 0) ? 'domains/add' : 'domains/edit/' + vm.form.id
      axios.post(process.env.VUE_APP_API_URL + url, vm.form).then(function (response) {
        vm.domains = response.data.data
        vm.load()
        vm.domainModal = false
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
    },
    deleteDomain (id) {
      let vm = this
      if (confirm('Are you sure that you want delete this domain ?')) {
        axios.delete(process.env.VUE_APP_API_URL + 'domains/delete/' + id).then(function (response) {
          vm.load()
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      }
    }
  }
};
</script>
<style>
  @import '../../assets/table.css';
  .modal-body {
    background: #eee;
  }
</style>
